import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "../../editableProps";
import Toggle from "@builder/components/general/Toggle";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { CashLedgerNode } from "@common/build/types";
import { updateCashLedgerSettings } from "@builder/store/slices/BuilderSlice/builderSlice";

const CashLedgerData: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const selectedNode = useAppSelector(getSelectedNode) as CashLedgerNode;
    const dispatch = useAppDispatch();

    const handleToggle = (v: boolean) => {
        dispatch(
            updateCashLedgerSettings({
                setting: v
            })
        );
    };

    return (
        <SidebarCollapse title="Cash ledger" parent={parent}>
            <Toggle label="Show opening/close time" checked={selectedNode.settings.showTime} callback={handleToggle} />
        </SidebarCollapse>
    );
};

export default CashLedgerData;
